import { accentColors } from '@radix-ui/themes/props'

export const stringToNamedColor = (input: string) => {
  let hash = 0

  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash)
  }

  const index = Math.abs(hash) % accentColors.length

  return accentColors[index]
}
